(function() {
    console.log('Product has been initiated customprodJS');
    document.addEventListener('DOMContentLoaded', function() {
        const variantBlock = document.querySelector('.product__block.product__block--lines.product__form__holder.block-padding');
        if (variantBlock) {
            variantBlock.style.setProperty('display', 'none', 'important');
            console.log('Hidden variant block via JS');
        } else {
            console.warn('Variant block not found');
        }
    });
})();